import { render, staticRenderFns } from "./NarrowNscItem.vue?vue&type=template&id=107c4ef6&scoped=true&"
import script from "./NarrowNscItem.vue?vue&type=script&lang=js&"
export * from "./NarrowNscItem.vue?vue&type=script&lang=js&"
import style0 from "./NarrowNscItem.vue?vue&type=style&index=0&id=107c4ef6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "107c4ef6",
  null
  
)

export default component.exports